<template>
    <div id="marketing_whatsapp_analytics" class="flex flex-col gap-2">
      <WhatsAppAnalyticsGrid />
      <WhatsAppEngagementActivity :type="analyticTypes.TABLE" />
      <WhatsAppEngagementActivity :type="analyticTypes.CHART" />
      <WhatsAppFunnel />
    </div>
</template>
  
<script setup>
  import WhatsAppAnalyticsGrid from "@/src/views/analytics/v2/marketing_campaign_analytics/whatsapp/WhatsAppAnalyticsGrid.vue";
  import WhatsAppEngagementActivity from "@/src/views/analytics/v2/marketing_campaign_analytics/whatsapp/WhatsAppEngagementActivity.vue";
  import WhatsAppFunnel from "@/src/views/analytics/v2/marketing_campaign_analytics/whatsapp/WhatsAppFunnel.vue";
  import { analyticTypes } from "@/src/constants/analyticConstants.js";
</script>
  
